export const COBROWSE_CHANGE_INITIAL_HTML = "initialHTML";
export const COBROWSE_CHANGE_CLICK = "click";
export const COBROWSE_CHANGE_FORMS = "forms";
export const COBROWSE_CHANGE_MOUSE_MOVE = "mousemove";
export const COBROWSE_CHANGE_DOM = "dom";
export const COBROWSE_CHANGE_ATTRIBUTES = "attributes";
export const COBROWSE_CHANGE_PING = "ping";
export const COBROWSE_CHANGE_WINDOW_SIZE = "windowSize";
export const COBROWSE_PING_INTERVAL = 10000;

export interface ICobrowseChangeInitialHtml {
    type: "initialHTML";
    html: string;
}

export interface ICobrowseChangeClick {
    type: "click",
    value: ICobrowseChangeClickValue[]
}

export interface ICobrowseChangeClickValue {
    offsetX: number,
    offsetY: number,
    target: string
}

export interface ICobrowseChangeForms {
    type: "forms",
    value: ICobrowseChangeFormsValue[]
}

export interface ICobrowseChangeFormsValue {
    target: string;
    value: any;
}

export interface ICobrowseChangeMouseMove {
    type: "mousemove",
    value: ICobrowseCometActionMouseMoveValue
}

export interface ICobrowseCometActionMouseMoveValue {
    target: string;
    offsetX: number;
    offsetY: number;
}

export interface ICobrowseChangeDom {
    type: "dom";
    path: string;
    html: string;
}

export interface ICobrowseChangeAttributes {
    type: "attrubutes";
    path: string;
    attributeName: string;
    value: string;
}

export interface ICobrowseChangePing {
    type: "ping";
}

export interface ICobrowseChangeWindowSize {
    type: "windowSize",
    value: ICobrowseChangeWindowSizeValue[]
}

export interface ICobrowseChangeWindowSizeValue {
    width: number;
    height: number;
}